import { logger } from '../App';
import { Protocol } from './constants';
import GameUtils from './gameutils';

export class MessageFactory {
    messagesList = {}

    static parseMessage(msg) {
        logger.log({ msg })
        var parts = msg.split(',');
        var object = null;
        try {
            var messageData = MessageFactory.messagesList[parts[0]];
            if (!messageData) {
                throw new Error("MessageFactory error parsing message structure not found for " + msg);
            }
            if ((parts.length - 1) !== messageData.parts_length) {
                throw new Error("MessageFactory error arguments count mismatch  expected " +
                    messageData.parts_length + " found " + (parts.length - 1));
            }
            object = {
                type: parts[0]
            };
            for (var i = 1; i < parts.length; i++) {
                var item = parts[i];
                var itemData = messageData.data[i - 1];
                switch (itemData.type) {
                    case "int":
                        object[itemData.name] = parseInt(item);
                        break;
                    case "number":
                        object[itemData.name] = parseFloat(item);
                        break;
                    case "base64":
                        object[itemData.name] = GameUtils.base64_decode(item);
                        break;
                    case "array":
                        object[itemData.name] = item.split(itemData.delimeter);
                        break;
                    case "objects":
                        object[itemData.name] = {};
                        var objsv = item.split(itemData.delimeter);
                        for (var v = 0; v < objsv.length; v++) {
                            var obj_itemv = objsv[v];
                            var obj_itemDatav = itemData.obj[v];
                            switch (obj_itemDatav.type) {
                                case "array":
                                    object[itemData.name][obj_itemDatav.name] = obj_itemv.split(obj_itemDatav.delimeter);
                                    break;
                                case "table":
                                    var subdata = obj_itemv.split(obj_itemDatav.delimeter);
                                    object[itemData.name][obj_itemDatav.name] = [];
                                    for (var u = 0, max = subdata.length; u < max; u++) {
                                        object[itemData.name][obj_itemDatav.name].push(subdata[u].split(obj_itemDatav.subdelimeter));
                                    }
                                    break;
                                default:
                                    object[itemData.name][obj_itemDatav.name] = obj_itemv;
                                    break;
                            }
                        }
                        break;
                    case "arrayobjects":
                        object[itemData.name] = [];
                        var objs = item.split(itemData.delimeter);
                        for (var k = 0; k < objs.length; k++) {
                            var objparts = objs[k].split(itemData.obj.delimeter);
                            var __obj = {};
                            for (var t = 0; t < objparts.length; t++) {
                                var obj_item = objparts[t];
                                var obj_itemData = itemData.obj.data[t];

                                switch (obj_itemData.type) {
                                    case "int":
                                        __obj[obj_itemData.name] = parseInt(obj_item);
                                        break;
                                    case "number":
                                        __obj[obj_itemData.name] = parseFloat(obj_item);
                                        break;
                                    case "base64":
                                        __obj[obj_itemData.name] = GameUtils.base64_decode(obj_item);
                                        break;
                                    case "array":
                                        __obj[obj_itemData.name] = item.split(obj_itemData.delimeter);
                                        break;

                                    default:
                                        __obj[obj_itemData.name] = obj_item;
                                        break;
                                }
                            }
                            object[itemData.name].push(__obj);
                        }
                        break;
                    default:
                        object[itemData.name] = item;
                        break;
                }
            }
        } catch (ex) {
            throw ex;
        }
        return object;
    }

    static createMessage() {
        if (arguments.length > 0) {
            var msgType = arguments[0];
            logger.log("msgType = " + msgType);
            var messageArr = [msgType];
            try {
                var messageData = MessageFactory.messagesList[msgType];
                logger.log(messageData, 'msh data', msgType);
                for (var i = 1; i < arguments.length; i++) {
                    var _type = "N/A";
                    var _type_expected = messageData[i - 1];
                    switch (_type_expected) {
                        case "array":
                            if (arguments[i] instanceof Array) {
                                _type = "array";
                            }
                            break;

                        default:
                            _type = typeof arguments[i];
                            break;
                    }
                    if (_type_expected !== _type) {
                        throw new Error("MessageFactory error argument at position " + i + " expected " + _type_expected + " found " + _type);
                    }
                    messageArr.push(arguments[i]);
                }
                return messageArr.join(Protocol.DELIMETER);
            } catch (ex) {
                logger.log(ex);
            }
        }
        return null;
    }
    ;
}

